import {
  type ErrorStatus,
  errorStatusStringSchema,
} from '../schemas/errorStatusSchema';

/**
 * An error without sensitive info in its message that can be sent to the
 * frontend client.
 */
export class ClientSafeError extends Error {
  constructor(public errorStatus: ErrorStatus) {
    super(JSON.stringify(errorStatus));
  }
}

export function isClientSafeError(e: unknown): e is ClientSafeError {
  try {
    return errorStatusStringSchema.safeParse((e as Error).message).success;
  } catch {
    return false;
  }
}

export const tryParseErrorStatus = (message?: string) =>
  errorStatusStringSchema.safeParse(message).data;
